function getConfig(name, defaultValue = null) {
    // If inside a docker container, use window.ENV
    if (window.ENV !== undefined) {
        return window.ENV[name] || defaultValue;
    }

    return process.env[name] || defaultValue;
}

export function getBackendUrl() {
    const configuredUrl = getConfig('REACT_APP_BACKEND_URL');
    if (typeof window !== "undefined") {
        const hostname = window.location.hostname;
        if (hostname === "localhost" || hostname === "127.0.0.1") {
            return configuredUrl ? configuredUrl.replace("http://127.0.0.1:", "http://localhost:") : "http://localhost:4000";
        }
        // Se estiver rodando em domínio de produção mas configuredUrl for localhost ou vazio
        if (!configuredUrl || configuredUrl.includes("localhost") || configuredUrl.includes("127.0.0.1")) {
            if (hostname.includes("atendechatpro.com.br")) {
                return "https://api.atendechatpro.com.br";
            }
            return `https://${hostname.replace(/^app\./, "api.")}`;
        }
    }
    return configuredUrl || "https://api.atendechatpro.com.br";
}

export function getHoursCloseTicketsAuto() {
    return getConfig('REACT_APP_HOURS_CLOSE_TICKETS_AUTO');
}

export function getFrontendPort() {
    return getConfig('SERVER_PORT');
}

export function getPrimaryColor() {
    return getConfig("REACT_APP_PRIMARY_COLOR");
}

export function getPrimaryDark() {
    return getConfig("REACT_APP_PRIMARY_DARK");
}

export function getNumberSupport() {
    return getConfig("REACT_APP_NUMBER_SUPPORT");
}
